import React from "react";
import { View, ViewStyle } from "react-native";
import { SvgXml } from "react-native-svg";
import type { PaymentIconInternalProps } from "./types";

export const PaymentIcon: React.FC<PaymentIconInternalProps> = ({
  size = 18,
  svgContent,
  style,
  testID,
  "aria-label": ariaLabel,
}) => {
  const width = Math.round(size * (4 / 3));
  const height = size;

  const containerStyle: ViewStyle = {
    width,
    height,
    alignItems: "center",
    justifyContent: "center",
    ...(style as ViewStyle),
  };

  if (!svgContent) {
    return <View style={containerStyle} testID={testID} />;
  }

  return (
    <View
      style={containerStyle}
      testID={testID}
      accessible={!!ariaLabel}
      accessibilityLabel={ariaLabel}
      accessibilityRole={ariaLabel ? "image" : undefined}
    >
      <SvgXml xml={svgContent} width="100%" height="100%" />
    </View>
  );
};
